import { FunctionComponent } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Col, Row } from 'react-styled-flexboxgrid';

import { Datepicker } from '../../../../atoms/Form';
import { safeFormattedIntlString } from '../../../../formatters';
import { DateRubric } from '../../Datatable.types';
import { DatatableFiltersModel } from '../DatatableFiltersModel';

import { useFilterDate } from './FiltersDate.hooks';
import FiltersDateTag from './FiltersDateTag';
import messages from './messages';

const FiltersDate: FunctionComponent<{
  filter: DateRubric;
  onChange: (selectedFilter: DateRubric) => void;
  dataTestId?: string;
}> = ({ filter, onChange, dataTestId }) => {
  const { startDate, endDate, handleStartDateChange, handleEndDateChange } =
    useFilterDate({ filter, onChange });

  const { control } = useFormContext();

  return (
    <DatatableFiltersModel
      title={filter.label}
      tag={
        <FiltersDateTag
          startDate={startDate}
          endDate={endDate}
          dataTestId={`${dataTestId}_filterDate_tag_${filter.name}`}
        />
      }
      filterContent={
        <Row>
          <Col xs={6}>
            <Controller
              name={`filterStartDate_${filter.name}`}
              control={control}
              render={({ field }) => (
                <Datepicker
                  ref={field.ref}
                  name={field.name}
                  value={field.value}
                  onChange={(newDate) => {
                    field.onChange(newDate || null);
                    handleStartDateChange(newDate);
                  }}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  placeholder={safeFormattedIntlString(messages.minValue)}
                  isClearable
                  maxDate={endDate || new Date()}
                  dataTestId={`${dataTestId}_filterStartDate_${filter.name}`}
                />
              )}
            />
          </Col>
          <Col xs={6}>
            <Controller
              name={`filterEndDate_${filter.name}`}
              control={control}
              render={({ field }) => (
                <Datepicker
                  ref={field.ref}
                  name={field.name}
                  value={field.value}
                  onChange={(newDate) => {
                    field.onChange(newDate || null);
                    handleEndDateChange(newDate);
                  }}
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  placeholder={safeFormattedIntlString(messages.maxValue)}
                  isClearable
                  minDate={startDate}
                  maxDate={new Date()}
                  dataTestId={`${dataTestId}_filterEndDate_${filter.name}`}
                />
              )}
            />
          </Col>
        </Row>
      }
    />
  );
};

export default FiltersDate;
